import type { ComponentChildren } from "preact";
import { OrgNameHeader } from "./org-name-header";
import { OrgTabs } from "./org-tabs";

type OrgLayoutProps = {
  orgId: string;
  orgName: string;
  logoUrl?: string | null;
  isAdmin: boolean;
  activeTab: "activity" | "members" | "forms" | "settings";
  memberCount?: number;
  formCount?: number;
  children: ComponentChildren;
  /** Optional custom header to render instead of OrgNameHeader */
  renderHeader?: (props: {
    orgId: string;
    orgName: string;
    logoUrl?: string | null;
    isAdmin: boolean;
  }) => preact.JSX.Element;
};

export function OrgLayout({
  orgId,
  orgName,
  logoUrl,
  isAdmin,
  activeTab,
  memberCount,
  formCount,
  children,
  renderHeader,
}: OrgLayoutProps) {
  return (
    <div class="flex justify-center">
      <div class="w-full max-w-2xl flex flex-col gap-6">
        {/* Header */}
        {renderHeader ? (
          renderHeader({
            orgId,
            orgName,
            logoUrl,
            isAdmin,
          })
        ) : (
          <OrgNameHeader orgId={orgId} orgName={orgName} logoUrl={logoUrl} />
        )}

        {/* Navigation tabs */}
        {isAdmin && (
          <OrgTabs
            orgId={orgId}
            activeTab={activeTab}
            memberCount={memberCount}
            formCount={formCount}
          />
        )}

        {/* Page content */}
        {children}
      </div>
    </div>
  );
}
